<template>
  <LetterLayout :model="model" v-on="$attrs" only-show-seal-in-from hide-indents date-alignment="start" hide-footer>

    <template #subject v-if="!first">
      <div class="fw-bold">
        Second Notice of Violation and Demand for Compliance - Immediate Action Required
      </div>
    </template>

    <p>
      Dear Property Owner:
    </p>
    <template v-if="first">
      <p>
        The Town of Freeport routinely monitors publicly available short-term rental hosting platforms and compares advertised listings with the Town's registration records.
      </p>
      <p>
        Through this process, a property associated with your ownership was identified as being advertised for short-term rental use. However, Town records do not show a current Short-Term Residential Rental Registration for the property. The Freeport Short-Term Residential Rental Registration Ordinance requires all short-term rentals to be registered with the Town prior to operation.
      </p>
      <p>
        We recognize that online listings may not always reflect current property use. If the property is no longer being used as a short-term rental and is now used solely as a private residence, please notify us by phone or email so that we can update our records.
      </p>
      <p>
        If the property is currently being used as a short-term rental, registration can be completed entirely online at www.FreeportMaine.com. The Clerk’s Licensing page provides a link to complete the Short-Term Rental Registration process and pay the applicable fee online.
      </p>
      <p>
        Our goal is to maintain accurate records of active short-term rentals operating in Freeport and to ensure compliance with local ordinances. We respectfully request a response within 15 days of the date of this notice.
      </p>
      <p>
        Thank you for your cooperation.
      </p>
    </template>
    <template v-else>
      <p>
        This letter serves as a second notice regarding a potential violation of the Town of Freeport's Short-Term Residential Rental Registration Ordinance.
      </p>
      <p>
        The Town previously notified you that a property under your ownership appeared to be operating as a short-term rental without the registration required by municipal ordinance. As of the date of this notice, the Town has not received sufficient information demonstrating compliance or otherwise resolving the matter.
      </p>
      <p>
        The operation of a short-term rental without the required registration is not permitted under Chapter 61 of the Town's Code of Ordinances. Property owners who offer dwelling units for short-term rental are responsible for ensuring that all registration, zoning, occupancy, parking, and related requirements are satisfied prior to and during operation.
      </p>
      <p>
        The Town strongly prefers to obtain compliance voluntarily; however, the requirements of the ordinance are mandatory and must be followed by all short-term rental operators. Continued operation without the required registration may result in further enforcement action as authorized under applicable municipal ordinances.
      </p>
      <div>
        Accordingly, you must take one of the following actions within 10 days of this notice:
        <ul>
          <li>
            Submit the required Short-Term Residential Rental Registration application, supporting documentation, and applicable fees; or
          </li>
          <li>
            Cease all short-term rental activity until the property is brought into compliance; or
          </li>
          <li>
            Contact the Town immediately if you believe this notice has been issued in error.
          </li>
        </ul>
      </div>
      <p>
        Failure to respond or otherwise resolve this matter may result in the Town pursuing additional enforcement measures available under law.
      </p>
      <p>
        We encourage you to contact the Town Clerk’s Office promptly to discuss the steps necessary to achieve compliance and avoid further action.
      </p>
    </template>

    <template #signature>
      <div>Sincerely,</div>
      <br/>
      <br/>
      <img :src="signature" height="56" />
      <br/>
      <div>
        <template v-if="first">
          Town of Freeport
        </template>
        <template v-else>
          Christine Wolfe
        </template>
      </div>
      <div>Town Clerk’s Office</div>
      <div>30 Main Street</div>
      <div>Freeport, ME 04032</div>
      <div>(207) 865-4743 x123</div>
      <div>cwolfe@freeportmaine.com</div>
    </template>
  </LetterLayout>
</template>

<script>
import LetterLayout from "@/components/letters/LetterLayout.vue";
import {LetterContext} from "@/models/letterContext";
import signature from './freeport-signature.png';

export default {
  components: {LetterLayout},
  props: {
    model: LetterContext,
    first: Boolean
  },
  data() {
    return { signature };
  }
}
</script>
